<div class="max-w-4xl mx-auto">
  <div class="bg-white rounded-lg shadow-md p-6">
    <h1 class="text-3xl font-bold text-slate-800 mb-6">
      Ergebnisse
    </h1>

    <!-- Category Chips -->
    <div class="flex gap-2 overflow-x-auto pb-4 mb-6 border-b border-slate-200 scrollbar-hide">
      @for (category of categories; track category.id) {
        <button
          (click)="selectCategory(category.id)"
          [class.bg-slate-600]="selectedCategory() === category.id"
          [class.text-white]="selectedCategory() === category.id"
          [class.bg-slate-100]="selectedCategory() !== category.id"
          [class.text-slate-700]="selectedCategory() !== category.id"
          [class.hover:bg-slate-200]="selectedCategory() !== category.id"
          [class.hover:bg-slate-700]="selectedCategory() === category.id"
          class="px-4 py-2 rounded-full font-medium whitespace-nowrap transition-colors flex-shrink-0">
          {{ category.label }}
        </button>
      }
    </div>

    <!-- File List -->
    <app-file-list
      [files]="files"
      [downloadPath]="getCurrentCategory().downloadPath"
      [isLoading]="isLoading"
      [error]="error">
    </app-file-list>
  </div>
</div>
